export default "__VITE_ASSET__DLX1y$L4__"